import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { PriceModel } from 'app/models/price-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { ProductModel } from 'app/models/product-model';
import { Constants } from 'app/components/utils/Constants';
import { Log } from 'app/core/logging/log';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryModel } from 'app/models/category-model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { DiscountModel } from 'app/models/discount-model';


@Component({
  selector: 'app-admin-product',
  templateUrl: './admin-product.page.html',
  styleUrls: ['./admin-product.page.scss'],
})
export class AdminProductPage implements OnInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  totalElements: number = 0;
  pageSize = 50;
  pageIndex = 0;
  products: ProductModel[] = [];
  priceLocker: PriceModel[] = [];
  categories: CategoryModel[] = [];
  isModalOpen = false;
  displayedColumns: string[] = ['category', 'channel', 'price'];
  dataSource = new MatTableDataSource<ProductModel>([]);


  constructor(    
    private restService: RestService,
    public appService: AppService,
    private dialog: MatDialog) {}

  ngOnInit() {
    this.getCategories();
    this.getPrices();
    this.getProducts();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  productRowClass = (row: ProductModel) => ({
    disabled: !row?.enabled
  });

  openNew() {
    this.openDetails();
  }

  openDetails(product?: ProductModel) {
      const currentProduct = product ?? ({
        prices: [],
        categoryId: null,
        category: null,
        enabled: true,
        channel: 'ANY_CHANNEL',
        createdAt: 0,
        updatedAt: 0
      } as ProductModel);

      let dialogRef = this.dialog.open(ProductModalContent, {
        panelClass: 'responsive-dialog',
        data: { 
          product: currentProduct, 
          isNew: currentProduct.id == undefined,
          categories: this.categories,
          priceLocker: this.priceLocker
        }
      });
      dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.getProducts());
  }

  cancel() {
    
  }

  onWillDismiss(event: Event) {
    this.isModalOpen = false;
  }

  getProducts(){
    this.restService.getProducts().subscribe(result => {
      this.products = result;
      this.dataSource.data = result;
    });
  }

  getCategories(){
    this.restService.getCategories().subscribe(result => {
      this.categories = result;
    });
  }

  getPrices(){
    this.restService.getPrices().subscribe(result => {
      this.priceLocker = result;

    });
  }

}

@Component({
  selector: 'app-modal-content',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ProductModalContent implements OnInit {
  product: ProductModel = {
    prices: [],
    categoryId: null,
    category: null,
    enabled: true,
    channel: 'ANY_CHANNEL',
    createdAt: 0,
    updatedAt: 0
  } as ProductModel;
  categories: CategoryModel[] = [];
  priceLocker: PriceModel[] = [];
  relatedDiscounts: DiscountModel[] = [];
  discountsLoaded = false;
  isNew: boolean;
  form: FormGroup;
  priceFb: FormGroup;

  constructor(
              @Inject(MAT_DIALOG_DATA) public data: { 
                product: ProductModel, 
                isNew: boolean, 
                categories:CategoryModel[], 
                priceLocker:PriceModel[]  
              },
              public dialogRef: MatDialogRef<ProductModalContent>,
              private restService: RestService,
              public appService: AppService,
              private fb: FormBuilder) {
                const categoryId = this.resolveCategoryId(this.data?.product);
                this.product = {
                  ...this.product,
                  ...(this.data.product || {}),
                  categoryId,
                  prices: this.data.product?.prices || []
                };
                this.categories = this.normalizeCategories(this.data.categories);
                this.isNew = this.data.isNew;
                this.priceLocker = this.data.priceLocker;
              }


  ngOnInit(): void {
    Log.debug('ProductModalContent', { product: this.product });

    this.loadCategoriesIfNeeded();

    const priceFb = this.fb.array(
      this.product.prices?.map(p => this.createPrice(p)) || []
    );

    this.form = this.fb.group({
      id: [this.product.id],
      categoryId: [this.resolveCategoryId(this.product), [Validators.required]],
      channel: [this.product.channel ?? 'ANY_CHANNEL'],
      enabled: [this.product.enabled ?? true],
      textos: this.fb.group({
        nombre: ['Box Mediano'],
        descripcion: ['Locker mediano reservable por día u horas']
      }),
      prices: priceFb
    });
    setTimeout(()=>{
      this.form.markAsTouched();
      this.form.updateValueAndValidity();
    }, 100);
    
  }

  private resolveCategoryId(product?: Partial<ProductModel> & { category?: Partial<CategoryModel> }): number | null {
    const rawCategoryId: unknown = product?.categoryId ?? product?.category?.id ?? null;
    if (rawCategoryId == null || rawCategoryId === '') {
      return null;
    }

    const normalizedCategoryId = Number(rawCategoryId);
    return Number.isNaN(normalizedCategoryId) ? null : normalizedCategoryId;
  }

  private normalizeCategories(categories: CategoryModel[] = []): CategoryModel[] {
    return (categories || []).map(category => ({
      ...category,
      id: category?.id == null ? undefined : Number(category.id)
    }));
  }

  private loadCategoriesIfNeeded(): void {
    if (this.categories?.length) {
      return;
    }

    this.restService.getCategories().subscribe(result => {
      this.categories = this.normalizeCategories(result || []);
      const categoryId = this.resolveCategoryId(this.product);
      if (categoryId != null) {
        this.form?.get('categoryId')?.setValue(categoryId);
      }
    });
  }

  loadRelatedDiscounts() {
    if (this.discountsLoaded) {
      return;
    }

    const productId = this.product?.id;
    if (!productId) {
      this.relatedDiscounts = [];
      this.discountsLoaded = true;
      return;
    }

    this.restService.getDiscounts().subscribe((discounts: DiscountModel[]) => {
      this.relatedDiscounts = (discounts || []).filter(discount =>
        Array.isArray(discount.productIds) && discount.productIds.includes(productId)
      );
      this.discountsLoaded = true;
    });
  }

  onTabChange(index: number) {
    if (index === 2) {
      this.loadRelatedDiscounts();
    }
  }

  createPrice(data: PriceModel): FormGroup {
    return this.fb.group({
      id:        [data.id],
      price:     [data.price, [Validators.required]],
      minPeriod: [data.minPeriod, [Validators.required, Validators.min(0)]],
      maxPeriod: [data.maxPeriod, [Validators.required]],
      period:    [data.period, [Validators.required]],
      type:      [data.type, [Validators.required]],
      unit:      [data.unit, [Validators.required]],
      businessHours: [data.businessHours]
    });
}

  addPrice() {
    let price:PriceModel = {
      id: null,
      price: 0,
      minPeriod: 0,
      maxPeriod: 0,
      period: 0,
      type: '',
      unit: '',
      businessHours: false,
      createdAt: 0,
      updatedAt: 0
    };
    this.prices.push(this.createPrice(price));
  }

  removePrice(index: number) {
    this.prices.removeAt(index);
  }

  get prices(): FormArray {
    return this.form.get('prices') as FormArray;
  }

  save() {
    Log.debug('ProductModalContent confirm', { product: this.product });
    if (this.form.invalid) return;

    const categoryId = this.resolveCategoryId(this.form.value as Partial<ProductModel>);
    this.form.get('categoryId')?.setValue(categoryId);

    if(this.isNew){
      this.postProduct();
    }else{
      this.putProduct();
    }
  }

  postProduct(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.postProduct(this.form.value).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.dialogRef.close({ updated: true });
    });
  }

  putProduct(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.putProduct(this.form.value).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.dialogRef.close({ updated: true });
    });
  }

  delete(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.deteleProduct(this.product.id).subscribe(result => {
      this.dialogRef.close({ updated: true });
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
    });
  }
  

  close() {
    this.dialogRef.close();
  }

  discountLabel(discount: DiscountModel): string {
    if (!discount) {
      return '';
    }

    const suffix = discount.discountType === 'PERCENTAGE'
      ? `${discount.discount}%`
      : `${discount.discount}€`;

    return `${discount.code} - ${suffix}`;
  }
  
}

